module.exports = __webpack_public_path__ + "src/app/assets/images/logo-name.svg";